/**
 * Aims at providing getter and renaming what is necessary
 */


class SharingSessionDescriptor {
  constructor(sharingSession) {
    const {
      organisation = {},
      application = {},
      scenario = {},
      share = {}
    } = sharingSession
    this.rawOrganisation = organisation
    this.rawApplication = application
    this.rawScenario = scenario
    this.rawShare = share
  }

  getWebsocketAddress() {
    return this.rawShare.socketAddress
  }

  getSessionDefinition() {
    return this.rawShare.sessionData
  }

  getCallbackUrl() {
    return this.rawShare.callbackEndpoint
  }

  getQrCodeUrl() {
    return this.rawShare.qrCodeUrl
  }

  getApplicationId() {
    return this.rawApplication.id
  }

  getOrganisation() {
    return this.rawOrganisation
  }

  getApplication() {
    return this.rawApplication
  }

  getScenario() {
    return this.rawScenario
  }

  getAttributes() {
    const { attributes = [] } = this.rawShare
    const rememberMeIdAttribute = attributes.find(item => item.attributeId === 'remember_me')
    if (rememberMeIdAttribute) {
      return [
        ...attributes.filter(item => item !== rememberMeIdAttribute),
        rememberMeIdAttribute
      ]
    }
    return attributes
  }

  getIdentityProfile() {
    const { identityProfile } = this.rawShare
    return identityProfile
  }

  getAdvancedIdentityProfile() {
    const { advancedIdentityProfile } = this.rawShare
    return advancedIdentityProfile
  }
}

export default SharingSessionDescriptor

/**
 * SHARING SESSION as received from web-share API
 */
/*
{
  organisation: {
    id: '6246d216-6461-4202-a1b2-9422aa0f0387',
    name: 'My Lovely Organisation',
    status: 'VERIFIED'
  },
  application: {
    id: 'ae2e7e7b-04f9-4725-93bc-3a3d2de2c5e2',
    logoUrl: 'https://hub.public.stg1.dmz.yoti.com/api/v1/applications/ae2e7e7b-04f9-4725-93bc-3a3d2de2c5e2/logo',
    name: 'Test Application 1',
    connectId: 'c9189abe-3e34-4c1f-9c8c-e90ecbb4d060',
    backgroundColor: '77ceee',
    contactUrl: null,
    privacyUrl: 'https://www.yoti.com/privacypolicy'
  },
  scenario: {
    applicationId: 'ae2e7e7b-04f9-4725-93bc-3a3d2de2c5e2',
    callback_endpoint: '/test',
    id: 'f7ea87e6-afd4-4c0d-ad69-420280d47124',
    name: 'Test Scenario 1',
    scenarioId: 'd9d54a43-8cd6-48ca-880e-7fd4bfaea11f'
  },
  share: {
    sessionData: 'proto_CiQ4OGQ3Y2U1OC01ZjAyLTQ4NWYtODZlYy0yYmEyMDU3NjVlMzkSB2xkNS5nYnIaCHliNEVKN1RV',
    sessionTimeout: 180,
    sessionTtl: 179,
    sharingToken: '0hc6Eg+rzM25zuD928NokHma5AvUZmfOZqJTt8HyDKfrI82i4FTolVd4BhCMQz39',
    callbackEndpoint: 'https://www.yoti.com/test',
    socketAddress: 'wss://connect.public.stg1.dmz.yoti.com/api/v1',
    qrCodeUrl: 'https://code.public.stg1.dmz.yoti.com/CAEaJDZiNDAzMzg1LWEzZjYtNDg2OS05MWU4LWE5ZWVmZjM2YjE3YTAC',
    attributes: [ {
      label: 'Photo', attributeId: 'selfie', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Full Name', attributeId: 'full_name', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Given Name(s)', attributeId: 'given_names', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Family Name', attributeId: 'family_name', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Mobile Number', attributeId: 'phone_number', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Email Address', attributeId: 'email_address', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Date of Birth', attributeId: 'date_of_birth', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Address', attributeId: 'structured_postal_address', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Gender', attributeId: 'gender', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Nationality', attributeId: 'nationality', type: 'raw', authentication: false, values: {}
    }, {
      label: 'Passport details',
      attributeId: 'document_details',
      type: 'raw',
      authentication: false,
      values: { source: 'PASSPORT' },
      source: 'PASSPORT'
    }, {
      label: 'Driving Licence details',
      attributeId: 'document_details',
      type: 'raw',
      authentication: false,
      values: { source: 'DRIVING_LICENCE' },
      source: 'DRIVING_LICENCE'
    }, {
      label: 'PASS card details',
      attributeId: 'document_details',
      type: 'raw',
      authentication: false,
      values: { source: 'PASS_CARD' },
      source: 'PASS_CARD'
    }, {
      label: 'National ID details',
      attributeId: 'document_details',
      type: 'raw',
      authentication: false,
      values: { source: 'NATIONAL_ID' },
      source: 'NATIONAL_ID'
    }, {
      label: 'Photo of Passport',
      attributeId: 'document_images',
      type: 'raw',
      authentication: false,
      values: { source: 'PASSPORT' },
      source: 'PASSPORT'
    }, {
      label: 'Photos of Driving Licence',
      attributeId: 'document_images',
      type: 'raw',
      authentication: false,
      values: { source: 'DRIVING_LICENCE' },
      source: 'DRIVING_LICENCE'
    }, {
      label: 'Photo of PASS card',
      attributeId: 'document_images',
      type: 'raw',
      authentication: false,
      values: { source: 'PASS_CARD' },
      source: 'PASS_CARD'
    }, {
      label: 'Photos of National ID',
      attributeId: 'document_images',
      type: 'raw',
      authentication: false,
      values: { source: 'NATIONAL_ID' },
      source: 'NATIONAL_ID'
    }, {
      label: 'Photo Authentication', attributeId: 'selfie_requested', type: 'raw', authentication: true, values: {}
    }, {
      label: 'Remember Me ID', attributeId: 'remember_me', type: 'raw', authentication: false, values: {}
    } ]
  }
}
*/
